<div class="offline-banner" [class.visible]="isVisible" [class.online]="isOnline && !showBackOnline" [class.back-online]="showBackOnline">
  <div class="banner-content">
    <!-- Back online state -->
    @if (showBackOnline && isOnline && queueCount === 0) {
      <span class="status-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
          <polyline points="22 4 12 14.01 9 11.01"></polyline>
        </svg>
      </span>
      <span class="message">
        {{ 'network.back_online_refresh' | translate }}
      </span>
      <button class="btn-refresh" (click)="refreshPage()">
        {{ 'network.refresh' | translate }}
      </button>
      <button class="btn-dismiss" (click)="dismissBanner()" aria-label="Dismiss">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>
    }

    <!-- Offline state -->
    @if (!isOnline) {
      <span class="status-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <line x1="1" y1="1" x2="23" y2="23"></line>
          <path d="M16.72 11.06A10.94 10.94 0 0 1 19 12.55"></path>
          <path d="M5 12.55a10.94 10.94 0 0 1 5.17-2.39"></path>
          <path d="M10.71 5.05A16 16 0 0 1 22.58 9"></path>
          <path d="M1.42 9a15.91 15.91 0 0 1 4.7-2.88"></path>
          <path d="M8.53 16.11a6 6 0 0 1 6.95 0"></path>
          <line x1="12" y1="20" x2="12.01" y2="20"></line>
        </svg>
      </span>
      @if (queueCount === 0) {
        <span class="message">
          {{ 'network.offline_message' | translate }}
        </span>
      }
      @if (queueCount > 0) {
        <span class="message">
          {{ 'network.offline_with_queue' | translate: { count: queueCount } }}
        </span>
      }
    }

    <!-- Online but has queued requests -->
    @if (isOnline && queueCount > 0) {
      @if (isRetrying) {
        <span class="status-icon syncing">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="23 4 23 10 17 10"></polyline>
            <polyline points="1 20 1 14 7 14"></polyline>
            <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"></path>
          </svg>
        </span>
      }
      @if (!isRetrying) {
        <span class="status-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="12" y1="8" x2="12" y2="12"></line>
            <line x1="12" y1="16" x2="12.01" y2="16"></line>
          </svg>
        </span>
      }
      @if (isRetrying) {
        <span class="message">
          {{ 'network.syncing_requests' | translate }}
        </span>
      }
      @if (!isRetrying) {
        <span class="message">
          {{ 'network.pending_requests' | translate: { count: queueCount } }}
        </span>
      }
    }

    <!-- Queue count badge -->
    @if (queueCount > 0) {
      <span class="queue-badge">
        {{ queueCount }}
      </span>
    }
  </div>

  <!-- Actions -->
  @if (queueCount > 0 && isOnline && !isRetrying) {
    <div class="banner-actions">
      <button class="btn-retry" (click)="retryNow()">
        {{ 'network.retry_now' | translate }}
      </button>
      <button class="btn-clear" (click)="clearQueue()">
        {{ 'network.clear_queue' | translate }}
      </button>
    </div>
  }
</div>
